// extracted by mini-css-extract-plugin
export default {"toggleFiltersButton":"side_filters-module___toggleFiltersButton___cdcaa90c","root":"side_filters-module___root___b07d1fdb"};